import { swSettings } from "app/common/services/swSettings";

export const getHasAdsIntelPackage = (): boolean => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- SwSettings is untyped
    return !!swSettings.components?.Activation?.resources?.HasAdsIntelPackage;
};
